import { cn } from "@/lib/cn";

// Friendly "nothing here yet" block with an optional call to action.
export default function EmptyState({ icon: Icon, title, message, action, className }) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white/50 px-6 py-14 text-center dark:border-white/10 dark:bg-white/5",
        className
      )}
    >
      {Icon && (
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-500/10 text-brand-500">
          <Icon size={24} />
        </span>
      )}
      <h3 className="mt-4 text-base font-semibold text-slate-800 dark:text-white">
        {title}
      </h3>
      {message && (
        <p className="mt-1 max-w-sm text-sm text-slate-500 dark:text-slate-400">
          {message}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
